/**
 * Декодирует payload JWT без проверки подписи. Используется как fallback,
 * когда `supabase().auth.getClaims()` недоступен или вернул пустой ответ.
 */
export const decodeJwtPayload = (token) => {
    try {
        const payloadSegment = token.split(".")[1];
        if (!payloadSegment) {
            return null;
        }
        const base64 = payloadSegment.replace(/-/g, "+").replace(/_/g, "/");
        const paddingLength = (4 - (base64.length % 4)) % 4;
        const padded = base64 + "=".repeat(paddingLength);
        const binary = atob(padded);
        const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
        const json = new TextDecoder("utf-8").decode(bytes);
        return JSON.parse(json);
    }
    catch (error) {
        console.error("Error decoding JWT payload:", error);
        return null;
    }
};
